import {Alert, Stack, TextField} from "@mui/material";
import {useContext, useMemo, useState} from "react";
import AxiosContext from "../context/axios.context";
import {LoadingButton} from "@mui/lab";

export const OtpVerification = ({onValid, email, phoneNumber, otpToken, loading, verificationType, mairie }) => {
    const [ui, setUi] = useState({ resend: false, sent: false,  success: true, loading: loading,  message: '', });
    const [code, setCode] = useState<string>();
    const [otpRequestToken, setOtpRequestToken] = useState<string>(otpToken);
    const { value: { instance: axios } } = useContext(AxiosContext);
    

    const handleSubmit = async () => {
        setUi(prev => ({...prev, loading: true, success: false, message: '', sent: false }))
        
        await axios.post('/otp/check', {
            phoneNumber,
            code,
            otpRequestToken,
            email,
            verificationType // this will disable sms verification
        })
            .then(async({data}) => {
                if (data?.success) {
                    await onValid()   
                } else  {
                    setUi(prev => ({...prev, success: false, message: data?.message ?? 'Merci de prendre un rendez-vous pour aller dans le gestionnaire de compte.' }))
                }
                setUi(prev => ({...prev, loading: false }))
            }).catch(error => {
                setUi(prev => ({...prev, loading: false }))
                console.log(error)
            })
    }

    const handleResendOTP = () => {
        setUi(prev => ({...prev, resend: true, sent: false, hasError: false, success: true, codeIncorrect: false, message: '' }));
        axios.post('/otp/generate', {
            phoneNumber,
            email,
            verificationType,
            mairie
        }).then(({data}) => {
            if (data?.success) {
                setOtpRequestToken(data?.data?.otp_request_token)
            }
        }).finally(() => {
            setUi(prev => ({...prev, resend: false, sent: true }));
        })
    }

    return <>
        <Stack gap={3} className="w-full m-0">
            {verificationType === 'SMS' && <p>Pour confirmer votre rendez-vous, saisissez ici le code communiqué par SMS sur votre téléphone portable.</p>}
            {verificationType === 'EMAIL' && <p>Pour confirmer votre rendez-vous, saisissez ici le code communiqué par email.</p>}
            <TextField
                type={"number"}
                className={"bg-white"}
                placeholder={"Code"}
                onChange={e => setCode(e.target.value)}
            />
            <LoadingButton
                variant={"contained"}
                color={"secondary"}
                loading={ui.loading}
                disabled={!code || code.length !== 6}
                onClick={() => handleSubmit()}
            >Confirmer le rendez-vous</LoadingButton>
            { ui.sent && <Alert severity={"info"}>Un nouveau code a été envoyé.</Alert>}
            { ui.message && !ui.success && <Alert severity="error">{ui.message}</Alert>}
            <LoadingButton loading={ui.resend} variant={"text"} color={"secondary"} onClick={() => handleResendOTP()}>
                {verificationType === 'SMS' && 'Renvoyer le SMS'}
                {verificationType === 'EMAIL' && 'Renvoyer l\'email'}
            </LoadingButton>
        </Stack>
    </>
}
